import { atom } from "recoil";

const selectionProcessAtom = atom({
  key: 'selectionProcess',
  default: {
    payload: [],
    loading: false,
    total: 0
  }
});



const crudSelectionProcessAtom = atom({
  key: 'crudSelectionProcess',
  default: {
    status: 500,
    message: '',
    loading: false
  }
});


export { crudSelectionProcessAtom, selectionProcessAtom};